export const planetChartData = {
  type: 'doughnut',
  data: {
    labels: [''],
    datasets: [

      { // one line graph
        label: "Tiempo promedio",
        data: [15, 5],
        backgroundColor: [
          'rgba(0, 27, 122, 0.5)', // Blue
          'rgba(122, 0, 0, 0.5)',
          'rgba(54,73,93,.5)',
          'rgba(54,73,93,.5)',
          'rgba(54,73,93,.5)',
          'rgba(54,73,93,.5)',
          'rgba(54,73,93,.5)',
          'rgba(54,73,93,.5)'
        ],
        borderColor: [
          '#36495d',
          '#36495d',
          '#36495d',
          '#36495d',
          '#36495d',
          '#36495d',
          '#36495d',
          '#36495d',
          '#36495d',
        ],
        borderWidth: 3
      }

    ]
  },
  options: {
    rotation: 1 * Math.PI,
    circumference: 1 * Math.PI,
    cutoutPercentage: 60,
    responsive: true,
    // maintainAspectRatio: false,
    lineTension: 1,
    scales: {
      yAxes: [{
        ticks: {
          min: 0,
          beginAtZero: true,
          stacked: true,
          callback: function () {

            return '';
          }
        },
        scaleLabel: {
          display: true,
          fontSize: 12,

        },
        gridLines: {
          display: false,
        },
      }],
      xAxes: [{
        stacked: true,
        gridLines: {
          display: false,
        },
        ticks: {
          // Include a dollar sign in the ticks
          callback: function () {

            return '';
          }
        }
      }]
    },
    // title:{
    //   display:true,
    //   text:"yeah"
    // },
    legend: {
      display: false,

    },
    tooltips: {
      enabled: false,

      // callbacks: {
      //   label: function (tooltipItem, data) {
      //     var sumatotal = 0;
      //     data.datasets.forEach(function (value) {

      //       sumatotal = value.data[tooltipItem.index] + sumatotal;
      //     });
      //     var dataset = data.datasets[tooltipItem.datasetIndex];
      //     var currentValue = dataset.data[tooltipItem.index];

      //     var percentage = Math.floor((100 / sumatotal) * data.datasets[1].data[tooltipItem.index]);
      //     return data.datasets[tooltipItem.datasetIndex].label + ": " + currentValue + "   Porcentaje de errores contra productividad: " + percentage + "%";
      //   }
      // }
    }
  }
}

export default planetChartData;